import { render, staticRenderFns } from "./LearningPrograms.vue?vue&type=template&id=46be8243&scoped=true"
import script from "./LearningPrograms.vue?vue&type=script&lang=ts"
export * from "./LearningPrograms.vue?vue&type=script&lang=ts"
import style0 from "./LearningPrograms.vue?vue&type=style&index=0&id=46be8243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be8243",
  null
  
)

export default component.exports